/** @format */

import React from 'react';

export const UserContext = React.createContext();
export const UserDispatcherContext = React.createContext();

function UserProvider({ children }) {
  const [state, setState] = React.useState(false);

  return (
    <UserContext.Provider value={state}>
      <UserDispatcherContext.Provider value={setState}>{children}</UserDispatcherContext.Provider>
    </UserContext.Provider>
  );
}

export { UserProvider };
